import React from "react";

const ArrowForwardIcon = ({ height = 24, width = 24, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.4697 6.80273C11.7626 6.51006 12.2374 6.51006 12.5303 6.80273L17.1973 11.4697C17.2957 11.5683 17.3584 11.6885 17.3906 11.8145C17.3939 11.8272 17.3988 11.8395 17.4014 11.8525C17.4026 11.8587 17.4032 11.8649 17.4043 11.8711C17.4116 11.913 17.417 11.956 17.417 12C17.417 12.043 17.4113 12.0849 17.4043 12.126C17.3793 12.274 17.3114 12.416 17.1973 12.5303L12.5303 17.1963C12.2374 17.4892 11.7626 17.4892 11.4697 17.1963C11.1772 16.9034 11.1769 16.4285 11.4697 16.1357L14.8545 12.75H7.33301C6.91894 12.7498 6.58301 12.4141 6.58301 12C6.58301 11.5859 6.91894 11.2502 7.33301 11.25H14.8564L11.4697 7.86328C11.177 7.57037 11.1769 7.09557 11.4697 6.80273Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowForwardIcon;
